import {setup, run} from '../../snippets/php';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  price: {},
  create: {},
  'payment-methods': {},
  'line-items': {},
  mode: {},
  redirect: {},
  urls: {},
  portal: {},
  'run-server': {
    Component: CreateShellCommand(run),
  },
};

export default ({keys, merchant, client}) => `<?php

require 'vendor/autoload.php';
{+setup}
${comment && comment(merchant)}
\\Stripe\\Stripe::setApiKey('${keys.secret}');
{/setup}

header('Content-Type: application/json');

$YOUR_DOMAIN = '${
  client === 'react'
    ? 'http://localhost:3000/checkout'
    : 'http://localhost:4242/public'
}';

try {
  {+price}
  $prices = \\Stripe\\Price::all([
    // retrieve lookup_key from form data POST body
    'lookup_keys' => [$_POST['lookup_key']],
    'expand' => ['data.product']
  ]);
  {/price}

  {+create}
  $checkout_session = \\Stripe\\Checkout\\Session::create([
    {+payment-methods}
    'payment_method_types' => ['card'],
    {/payment-methods}
    {+line-items}
    'line_items' => [[
      'price' => $prices->data[0]->id,
      'quantity' => 1,
    ]],
    {/line-items}
    {+mode}
    'mode' => 'subscription',
    {/mode}
    {+urls}
    'success_url' => $YOUR_DOMAIN . '${
      client === 'react'
        ? '?success=true'
        : '/success.html?session_id={CHECKOUT_SESSION_ID}'
    }',
    'cancel_url' => $YOUR_DOMAIN . '${
      client === 'react' ? '?canceled=true' : '/cancel.html'
    }',
    {/urls}
    {?add-trial trial-period-days}
    'subscription_data' => [
      'trial_period_days' => 7,
    ],
    {/trial-period-days}
    {?add-discount discounts}
    'discounts' => [[
        'coupon' => '{{COUPON_ID}}',
    ]],
    {/discounts}
    {?add-customer customer}
    'customer' => 'cus_123',
    {/customer}
    {?automatic-tax automatic-tax-param}
    'automatic_tax' => [
      'enabled' => true,
    ],
    {/automatic-tax-param}
  ]);
  {/create}

  {+redirect}
  header("HTTP/1.1 303 See Other");
  header("Location: " . $checkout_session->url);
  {/redirect}
} catch (Error $e) {
  http_response_code(500);
  echo json_encode(['error' => $e->getMessage()]);
}`;
